export default {
  data() {
    return {
      // 项目包id
      id: null,
      // 在/projectnews点击的是通知还是指南
      type: '',
      // 在/projectnews点击的数组的索引
      index: null,
      // 获取的数据
      data: {},
      // 是否含有html标签
      isHTML: false
    }
  },
  methods: {
    // 根据type判断要调用的接口从后端获取数据
    getData() {
      const type = this.type
      const index = this.index
      if (type === 'notice') {
        // console.log('点击的是公告')
        this.$post('product_notices/search', {
          token: this.$store.state.id,
          offset: 0,
          length: 9999,
          package_id: this.id
        }).then(res => {
          // console.log(res)
          this.data = res.data.result.data[index]
          this.judgeIsHTML(this.data.content)
        })
      } else if (type === 'news') {
        // console.log('点击的是新闻')
        this.$post('product_news/search', {
          token: this.$store.state.id,
          offset: 0,
          length: 9999,
          package_id: this.id
        }).then(res => {
          // console.log(res)
          this.data = res.data.result.data[index]
          this.judgeIsHTML(this.data.content)
        })
      }
    },

    // 判断是否含有html标签
    judgeIsHTML(str) {
      var reg = /<[^>]+>/g;
      this.isHTML = reg.test(str)
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.index = this.$route.query.index
    this.getData()
  },
}